import { render, staticRenderFns } from "./MessageListMessageTrafficGroup.vue?vue&type=template&id=51d268ac&"
import script from "./MessageListMessageTrafficGroup.vue?vue&type=script&lang=js&"
export * from "./MessageListMessageTrafficGroup.vue?vue&type=script&lang=js&"
import style0 from "./MessageListMessageTrafficGroup.vue?vue&type=style&index=0&id=51d268ac&prod&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports